const actions = {
  ORDERS_EXECUTION_REQUEST: "ORDERS_EXECUTION_REQUEST",
  ORDERS_EXECUTION_SUCCESS: "ORDERS_EXECUTION_SUCCESS",

  ordersExecution: (startDate, endDate, selectedRestaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.ORDERS_EXECUTION_REQUEST,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
